<script>
  import {onMount} from "svelte";
  import TextField from "../utils/TextField.svelte";
  import Dropdown from "../utils/Dropdown.svelte";
  import { PHP } from "../store";

  export let options;
  export let value;
  export let defaultValue;
  export let url;
  export let title = "";
  export let error;

  $: {
    if (value === "open_site") url = $PHP.userBaseUrl;
    if (value === "close_notif") url = "";
  }
</script>

<style>
  .label {
    margin-bottom: 0;
  }
</style>

<div class="field">
  <label class="label is-small">{title}</label>
  <div class="field is-grouped is-horizontal">
    <div class="control">
      <Dropdown title="" bind:value bind:defaultValue {options} />
    </div>

    {#if value === 'open_link'}
      <div class="control is-expanded">
        <TextField
          title=""
          placeholder="Url"
          bind:value={url}
          error={(error || {}).url} />
      </div>
    {/if}
  </div>
</div>
